// ** React Imports
import { useState } from 'react'
import {useSkin} from "../../../../../utility/hooks/useSkin"
import NavbarUser from "../../navbar/NavbarUser"

// ** Horizontal Menu Components
import HorizontalNavMenuItems from './HorizontalNavMenuItems'
import themeConfig from '@configs/themeConfig'

const HorizontalMenu = ({ menuData, currentActiveItem, routerProps }) => {
  // ** States
  const [activeItem, setActiveItem] = useState(null)
  const [groupActive, setGroupActive] = useState([])
  const [openDropdown, setOpenDropdown] = useState([])
  const { skin } = useSkin()

  // ** On mouse enter push the ID to openDropdown array
  const onMouseEnter = id => {
    const arr = openDropdown
    arr.push(id)
    setOpenDropdown([...arr])
  }

  // ** On mouse leave remove the ID to openDropdown array
  const onMouseLeave = id => {
    const arr = openDropdown
    arr.splice(arr.indexOf(id), 1)
    setOpenDropdown([...arr])
  }

  return (
    <div className='navbar-container main-menu-content'>
      <ul className='nav navbar-nav' id='main-menu-navigation'>
        <div className={'d-flex flex-column align-self-center'} style={{marginLeft: '3%', marginRight: '3%'}}>
          <a href={'/'}><img width={88} height={20} className='fallback-logo' src={skin === 'light' ? themeConfig.app.appLogoCollapsed : themeConfig.app.appLogoCollapsedDarkMode} alt='logo'/></a>
        </div>
        <HorizontalNavMenuItems
          submenu={false}
          items={menuData}
          activeItem={activeItem}
          groupActive={groupActive}
          routerProps={routerProps}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          openDropdown={openDropdown}
          setActiveItem={setActiveItem}
          setGroupActive={setGroupActive}
          setOpenDropdown={setOpenDropdown}
          currentActiveItem={currentActiveItem}
        />
        <NavbarUser skin={'light'} />

      </ul>
    </div>
  )
}

export default HorizontalMenu
